import pick from "./pick";
import { INPUT_NAMES } from "../utils/config";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validators = {
	presence(value, options) {
		if (value === undefined || value === null || (String(value).trim() === "" && !options.allowEmpty)) {
			return options.message;
		}
	},
	email(value, options) {
		if (value !== undefined && value !== null && value !== "" && !EMAIL_REGEX.test(value)) {
			return options.message;
		}
	},
};

const constraints = {
	[INPUT_NAMES.email]: {
		presence: {
			allowEmpty: false,
			message: "validation.email",
		},
		email: {
			message: "validation.email",
		},
	},
	[INPUT_NAMES.firstName]: {
		presence: {
			allowEmpty: false,
			message: "validation.firstName",
		},
	},
	[INPUT_NAMES.lastName]: {
		presence: {
			allowEmpty: false,
			message: "validation.lastName",
		},
	},
	[INPUT_NAMES.name]: {
		presence: {
			allowEmpty: false,
			message: "validation.name",
		},
	},
	[INPUT_NAMES.phoneNumber]: {
		presence: {
			allowEmpty: false,
			message: "validation.phone",
		},
	},
	[INPUT_NAMES.company]: {
		presence: {
			allowEmpty: false,
			message: "validation.company",
		},
	},
	[INPUT_NAMES.recaptcha]: {
		presence: {
			allowEmpty: false,
			message: "validation.recaptcha",
		},
	},
};

// removing the parens creates an ambiguous arrow error
// eslint-disable-next-line no-extra-parens
export const isValid = errObj => (errObj ? false : null);

export default inputs => {
	const filteredConstraints = pick(constraints, Object.keys(inputs));
	const errors = {};

	Object.keys(filteredConstraints).forEach(field => {
		const fieldConstraints = filteredConstraints[field];
		Object.keys(fieldConstraints).forEach(validatorName => {
			const options = fieldConstraints[validatorName];
			const error = validators[validatorName](inputs[field], options);
			if (error) {
				if (!errors[field]) {
					errors[field] = [];
				}
				errors[field].push(error);
			}
		});
	});

	return Object.keys(errors).length > 0 ? errors : undefined;
};
